"use strict";

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstagramLogoIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVGIcon = require("../../SVGIcon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var InstagramLogoIcon = function InstagramLogoIcon(props) {
  return _react["default"].createElement(_SVGIcon.SvgIcon, _extends({
    viewBox: "0 0 30 30"
  }, props), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
    id: "a",
    d: "M0 .00946h29.99054v29.98697H0z"
  })), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", null, _react["default"].createElement("mask", {
    id: "b",
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: "#a"
  })), _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M14.9953.00946c-4.0725 0-4.58316.01727-6.18256.09024C7.21667.1725 6.1266.42601 5.1728.79673c-.98607.38315-1.82232.89589-2.65601 1.72952-.83364.83369-1.34637 1.66994-1.72953 2.65601C.41655 6.13607.16304 7.22613.09024 8.8222.01726 10.4216 0 10.93226 0 15.00476c0 4.07244.01726 4.5831.09024 6.1825.0728 1.59607.3263 2.68613.69702 3.63994.38316.98607.8959 1.82232 1.72953 2.65601.83369.83364 1.66994 1.34637 2.656 1.72959.95382.37065 2.04388.62416 3.63995.69696C10.41214 29.98274 10.9228 30 14.9953 30c4.07244 0 4.5831-.01726 6.1825-.09024 1.59607-.0728 2.68613-.3263 3.63994-.69696.98607-.38322 1.82232-.89595 2.65601-1.72959.83363-.83369 1.34637-1.66994 1.72958-2.656.37066-.95382.62417-2.04388.69697-3.63995.07297-1.5994.09024-2.11006.09024-6.1825 0-4.0725-.01727-4.58315-.09024-6.18256-.0728-1.59607-.32631-2.68613-.69697-3.63994-.38321-.98607-.89595-1.82232-1.72958-2.65601-.83369-.83363-1.66994-1.34637-2.65601-1.72952C23.86393.426 22.77387.1725 21.1778.0997 19.5784.02673 19.06774.00946 14.9953.00946zm0 2.70185c4.00387 0 4.47815.0153 6.05934.08744 1.46203.06667 2.25601.31095 2.7844.51631.69995.27202 1.19947.59696 1.72417 1.12173.52477.5247.8497 1.02422 1.12173 1.72416.20536.5284.44964 1.32238.51631 2.7844.07214 1.5812.08744 2.05548.08744 6.05941 0 4.00387-.0153 4.47816-.08744 6.05935-.06667 1.46202-.31095 2.256-.51631 2.7844-.27202.69994-.59696 1.19947-1.12173 1.72417-.5247.52476-1.02422.8497-1.72416 1.12172-.5284.20536-1.32238.44965-2.7844.51631-1.58096.07215-2.05519.08744-6.05935.08744-4.00423 0-4.4784-.0153-6.0594-.08744-1.46203-.06666-2.25602-.31095-2.78441-.5163-.69994-.27203-1.19947-.59697-1.72417-1.12173-.5247-.5247-.8497-1.02423-1.12172-1.72417-.20536-.5284-.44965-1.32238-.51631-2.7844-.07215-1.5812-.08744-2.05548-.08744-6.05935 0-4.00393.0153-4.47821.08744-6.0594.06666-1.46203.31095-2.25601.5163-2.7844.27203-.69995.59697-1.19947 1.12173-1.72417.5247-.52477 1.02423-.8497 1.72417-1.12173.5284-.20536 1.32238-.44964 2.7844-.51631 1.5812-.07214 2.05548-.08744 6.0594-.08744z",
    mask: "url(#b)"
  })), _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M14.94234 20.03846c-2.75085 0-4.9808-2.22995-4.9808-4.98074 0-2.75085 2.22995-4.9808 4.9808-4.9808 2.75079 0 4.98074 2.22995 4.98074 4.9808 0 2.75079-2.22995 4.98074-4.98074 4.98074zm0-12.65384c-4.23778 0-7.6731 3.43532-7.6731 7.6731 0 4.23772 3.43532 7.67305 7.6731 7.67305 4.23772 0 7.67304-3.43533 7.67304-7.67305 0-4.23778-3.43532-7.6731-7.67304-7.6731zM24.8077 6.9808c0 .98775-.80075 1.78843-1.7885 1.78843-.98769 0-1.78843-.80068-1.78843-1.78843s.80074-1.7885 1.78843-1.7885c.98775 0 1.7885.80075 1.7885 1.7885"
  })));
};

exports.InstagramLogoIcon = InstagramLogoIcon;